export const TIMEOUTS = {
  FORM_RESET: 10000,
  MESSAGE_DISPLAY: 5000,
  DEBOUNCE: 300,
};

export const ICONS = {
  PHONE: '📞',
  EMAIL: '📧',
  LOCATION: '📍',
  EMERGENCY: '🚨',
  LIGHTNING: '⚡',
  WHATSAPP: '📱',
};
